'use client';

import { useEffect } from 'react';
import { useAuthStore } from '@/lib/store/useAuthStore';
import { useNotificationStore } from '@/lib/store/useNotificationStore';

/**
 * Componente que inicializa a conexão WebSocket de notificações.
 * Deve ser renderizado uma vez no layout da aplicação.
 * Conecta automaticamente quando o usuário está autenticado.
 */
export function NotificationInit() {
  const userId = useAuthStore((s) => s.squadToken?.user_id);
  const connect = useNotificationStore((s) => s.connect);
  const disconnect = useNotificationStore((s) => s.disconnect);

  useEffect(() => {
    if (!userId) {
      disconnect();
      return;
    }

    connect(userId);

    return () => {
      disconnect();
    };
  }, [userId, connect, disconnect]);

  return null;
}
